import optionTypesClient from '@/client/options/definition/option-types.client';
import options from '@/options/definition/options';

// option types
// the toolbar will sort options in the order they are listed here
export default {
    backgroundImage: {
        metadata: {
            title: 'Background Image',
            kebab: 'background-image',
            icon: 'image',
        },

        image: options.backgroundImage,
        display: options.backgroundDisplay,
        size: options.backgroundImageSize,
        position: options.backgroundImagePosition,
        repeat: options.backgroundImageRepeat,
        attachment: options.backgroundImageAttachment,
        overlay: options.backgroundImageOverlay,
        overlayOpacity: options.backgroundImageOverlayOpacity,
    },

    carousel: {
        metadata: {
            title: 'Carousel',
            kebab: 'carousel',
            icon: 'presentation',
        },

        hideControls: options.carouselControls,
        speed: options.carouselSpeed,
        transitionEffect: options.carouselTransitionEffect,
        carouselPromoDataSource: options.carouselPromoDataSource,

        ...optionTypesClient.carousel,
    },

    component: {
        metadata: {
            title: 'Component',
            kebab: 'component',
            icon: 'sliders-h',
        },

        rowShading: options.rowShading,
        hoverTransition: options.hoverTransition,
        addPreset: options.addPreset,
        backgroundColor: options.backgroundColor,
        backgroundGradient: options.backgroundGradient,
        padding: options.padding,
        margin: options.margin,
        border: options.border,
        borderRadius: options.borderRadius,
        boxShadow: options.boxShadow,
        cursor: options.cursor,
        skewY: options.skewY,

        ...optionTypesClient.component,
    },

    drawerCollection: {
        metadata: {
            title: 'Drawer Collection',
            kebab: 'drawer-collection',
            icon: 'cabinet-filing',
        },

        drawerExpand: options.drawerExpand,
        drawerIconImage: options.drawerIconImage,

        ...optionTypesClient.drawerCollection,
    },

    dropdown: {
        metadata: {
            title: 'Nav Dropdown',
            kebab: 'navigation',
            icon: 'caret-square-down',
        },

        iconDisplay: options.dropdownIconDisplay,
        icon: options.dropdownIcon,
        direction: options.dropdownDirection,
        anchor: options.dropdownAnchor,
        trigger: options.dropdownTrigger,
        speed: options.dropdownSpeed,

        ...optionTypesClient.dropdown,
    },

    html: {
        metadata: {
            title: 'Data',
            kebab: 'html',
            icon: 'code',
        },

        flexEvents: options.flexEvents,
        formEndpoint: options.formEndpoint,
        formRequestType: options.formRequestType,
        htmlCustomAttributes: options.htmlCustomAttributes,
        isLink: options.isLink,
        dataDynamic: options.dataDynamic,
        inputChecked: options.inputChecked,
        inputName: options.inputName,
        inputType: options.inputType,
        inputPlaceholder: options.inputPlaceholder,
        inputValue: options.inputValue,
        inputOptions: options.inputOptions,
        inputRequired: options.inputRequired,
        inputValidation: options.inputValidation,
        inputValidationMessage: options.inputValidationMessage,
        cookie: options.cookie,
        cookieLoad: options.cookieLoad,
        idOverride: options.htmlIdOverride,
        tag: options.htmlTag,
        dateFormat: options.dateFormat,
        labelFor: options.labelFor,

        ...optionTypesClient.html,
    },

    image: {
        metadata: {
            title: 'Image',
            kebab: 'image',
            icon: 'image',
        },

        imageSelector: options.imageSelector,
        aspectRatio: options.aspectRatio,
        objectPosition: options.objectPosition,
        objectFit: options.objectFit,
        imageFilter: options.imageFilter,
        imageGradient: options.imageGradient,
        imageGradientOpacity: options.imageGradientOpacity,
        zoom: options.zoom,

        ...optionTypesClient.image,
    },

    layout: {
        metadata: {
            title: 'Layout',
            kebab: 'layout',
            icon: 'columns',
        },

        boxed: options.boxed,
        sticky: options.sticky,
        alignSelf: options.alignSelf,
        placement: options.placement,
        flexDirection: options.flexDirection,
        flexWrap: options.flexWrap,
        offset: options.offset,
        contentAlignment: options.contentAlignment,
        height: options.height,
        minHeight: options.minHeight,
        maxHeight: options.maxHeight,
        width: options.width,
        minWidth: options.minWidth,
        maxWidth: options.maxWidth,
        overflow: options.overflow,
        zIndex: options.zIndex,

        ...optionTypesClient.layout,
    },

    linkBuilder: {
        metadata: {
            title: 'Link Builder',
            kebab: 'link-builder',
            icon: 'wrench',
        },

        linkBuilder: options.linkBuilder,
    },

    nav: {
        metadata: {
            title: 'Navigation',
            kebab: 'navigation',
            icon: 'line-columns',
        },

        navDataSource: options.navDataSource,

        ...optionTypesClient.nav,
    },

    table: {
        metadata: {
            title: 'Table',
            kebab: 'table',
            icon: 'line-columns',
        },

        tableDataSource: options.tableDataSource,

        ...optionTypesClient.table,
    },

    text: {
        metadata: {
            title: 'Text',
            kebab: 'text',
            icon: 'font',
            iconSet: 'far',
        },

        textAlignment: options.textAlignment,
        color: options.color,
        fontSize: options.fontSize,
        fontWeight: options.fontWeight,
        fontStyle: options.fontStyle,
        ellipses: options.ellipses,
        maxCharacters: options.maxCharacters,
        textDecoration: options.textDecoration,
        textShadow: options.textShadow,
        textTransform: options.textTransform,
        fontFamily: options.fontFamily,
        letterSpacing: options.letterSpacing,
        lineHeight: options.lineHeight,

        ...optionTypesClient.text,
    },

    video: {
        metadata: {
            title: 'video',
            kebab: 'video',
            icon: 'video',
        },

        aspectRatioVideo: options.aspectRatioVideo,

        ...optionTypesClient.video,
    },

    visibility: {
        metadata: {
            title: 'Visibility',
            kebab: 'visibility',
            icon: 'eye',
        },

        visibility: options.visibility,
        disabled: options.disabled,
        opacity: options.opacity,

        ...optionTypesClient.visibility,
    },

    dynamicCollection: {
        metadata: {
            title: 'Dynamic Collection',
            kebab: 'dynamic-collection',
            icon: 'link',
        },

        dynamicCollection: options.dynamicCollection,
        dynamicCollectionIncludeLocations: options.dynamicCollectionIncludeLocations,
        dynamicCollectionItemWidth: options.dynamicCollectionItemWidth,
        dynamicCollectionItemGutter: options.dynamicCollectionItemGutter,
        dynamicCollectionLoader: options.dynamicCollectionLoader,
    },

    advancedTabbedNav: {
        metadata: {
            title: 'Advanced Tabbed Nav',
            kebab: 'advanced-tabbed-nav',
            icon: 'line-columns',
        },

        tabDockLocation: options.tabDockLocation,
        advancedTabbedNavTransition: options.advancedTabbedNavTransition,
    },

    googleMap: {
        metadata: {
            title: 'Google Maps',
            kebab: 'google-map',
            icon: 'map',
        },

        googleMapCoordinates: options.googleMapCoordinates,
        googleMapStyles: options.googleMapStyles,
    },

    hamburgerNav: {
        metadata: {
            title: 'Hamburger Nav',
            kebab: 'hamburger-nav',
            icon: 'bars',
        },

        breakpoint: options.hamburgerNavBreakpoint,
        slideDirection: options.hamburgerNavSlideDirection,
        slideSpeed: options.hamburgerNavSlideSpeed,
    },

    layeredContainer: {
        metadata: {
            title: 'Layered Container',
            kebab: 'layered-container',
            icon: 'layer-group',
        },

        layerTransition: options.layerTransition,

        ...optionTypesClient.layeredContainer,
    },

    search: {
        metadata: {
            title: 'Search',
            kebab: 'search',
            icon: 'search',
        },

        iconSearchCollapse: options.iconSearchCollapse,
        iconSearchUrl: options.iconSearchUrl,
        searchFacet: options.searchFacet,
        searchKeywordsFormId: options.searchKeywordsFormId,
        searchFacetValueToggle: options.searchFacetValueToggle,
    },

    calendar: {
        metadata: {
            title: 'Calendar',
            kebab: 'calendar',
            icon: 'calendar',
        },

        calendarFacetEventPage: options.calendarFacetEventPage,
        calendarFacetStartDate: options.calendarFacetStartDate,
        calendarFacetTitle: options.calendarFacetTitle,
        calendarFacetDateHighlight: options.calendarFacetDateHighlight,
        calendarFacetDateDot: options.calendarFacetDateDot,
        calendarFacetDateDotColor: options.calendarFacetDateDotColor,
        calendarFacetDateBar: options.calendarFacetDateBar,
        calendarFacetDateBarColor: options.calendarFacetDateBarColor,
        calendarFacetWeekdays: options.calendarFacetWeekdays,
        calendarFacetDay: options.calendarFacetDay,
    },

    accessibility: {
        metadata: {
            title: 'Accessibility',
            kebab: 'accessibility',
            icon: 'accessible-icon',
            iconSet: 'fab',
        },

        ariaLabel: options.ariaLabel,
        ariaLabelledBy: options.ariaLabelledBy,
        labelFor: options.labelFor,
        accessibilityRole: options.accessibilityRole,
        ariaHidden: options.ariaHidden,
    },
};
